
import React, { useState, useEffect } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

interface VideoPlayerProps {
  videoId: string;
  title: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoId, title }) => {
  const [isLoading, setIsLoading] = useState(true);
  
  // Set up preloading for the iframe with reduced timeout
  useEffect(() => {
    // Show at least a brief loading state
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300); // Reduced to 300ms for faster perceived performance
    
    return () => clearTimeout(timer);
  }, [videoId]);
  
  return (
    <div className="w-full overflow-hidden rounded-2xl shadow-sm bg-black aspect-video relative">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-hormony-charcoal/10">
          <Skeleton className="w-full h-full absolute" />
          <div className="w-16 h-16 rounded-full bg-hormony-coral/80 flex items-center justify-center shadow-lg z-10 animate-pulse">
            <div className="w-0 h-0 border-t-8 border-t-transparent border-l-12 border-l-white border-b-8 border-b-transparent ml-1"></div>
          </div>
        </div>
      )}
      
      <iframe
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute inset-0"
        onLoad={() => setIsLoading(false)}
        loading="lazy"
      ></iframe>
    </div>
  );
};

export default React.memo(VideoPlayer);
